exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".care-team-tasks--RrVWRib_kdmyPQBPE7_Bl {\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\n.care-team-tasks--RrVWRib_kdmyPQBPE7_Bl:not(.care-team-tasks--2DVN6qQCZMo1FgC-SmL6jX) {\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.care-team-tasks--RrVWRib_kdmyPQBPE7_Bl:not(.care-team-tasks--2DVN6qQCZMo1FgC-SmL6jX):hover {\n  text-decoration: none;\n}\n", ""]);

// exports
exports.locals = {
	"taskName": "care-team-tasks--RrVWRib_kdmyPQBPE7_Bl",
	"taskName": "care-team-tasks--RrVWRib_kdmyPQBPE7_Bl",
	"restricted": "care-team-tasks--2DVN6qQCZMo1FgC-SmL6jX",
	"restricted": "care-team-tasks--2DVN6qQCZMo1FgC-SmL6jX"
};